<template>
  <section class="information-box">
    <FloatingActionButtons
      :box="box"
      :index="index"
      :computedBoxesData="boxes"
      :activeFABIndex="activeFABIndex"
      @passActiveIndex="$emit('passActiveIndex', $event)"
      @showDeleteModal="showDeleteModal"
      @showEditModal="showEditModal"
      @showVisibilityModal="showVisibilityModal"
    />
    <div
      class="infoColumn"
      :style="{ backgroundColor: box.boxColor, color: box.boxText }"
    >
      <VisibilityModal
        @close="closeWithNo()"
        @editVisibility="editVisibility"
        :box="box"
        v-if="visibilityModalVisible"
      />

      <div class="card-header" v-if="box.roomAbilities[localLanguageTypesIndex].allowedHeaderContent">
        <div v-if="secondLanguage">
          <span
            class="card-title-custom"
            v-if="customFonts.customFonts"
            :style="{
              'font-family': customFonts.customFontCss,
              'font-size': customFonts.customFontSize,
            }"
            >{{ box.headline }}</span
          >
          <h4 class="card-title h4" v-else :style="{ color: box.boxText }">
            {{ box.headlineSec }}
          </h4>
        </div>
        <div v-else>
          <span
            class="card-title-custom"
            v-if="customFonts.customFonts"
            :style="{
              'font-family': customFonts.customFontCss,
              'font-size': customFonts.customFontSize,
            }"
            >{{ box.headline }}</span
          >
          <h4 class="card-title h4" v-else :style="{ color: box.boxText }">
            {{ box.headline }}
          </h4>
        </div>
        <ul class="inAndOut">
          <li v-if="box.checkin !== ''">
            <h5>
              {{
                secondLanguage
                  ? isCheckinEmpty(box.checkinTexts[1])
                  : isCheckinEmpty(box.checkinTexts[0])
              }}
            </h5>
            <span>{{
              secondLanguage ? box.checkins[1] : box.checkins[0]
            }}</span>
          </li>
          <li v-if="box.checkout !== ''">
            <h5>
              {{
                secondLanguage
                  ? isCheckoutEmpty(box.checkoutTexts[1])
                  : isCheckoutEmpty(box.checkoutTexts[0])
              }}
            </h5>
            <span>{{
              secondLanguage ? box.checkouts[1] : box.checkouts[0]
            }}</span>
          </li>
        </ul>
      </div>
      <div
        class="card-content"
        :class="{
          noCheckInOrCheckOut: box.checkin === '' && box.checkout === '',
          checkInOrCheckoutOverlap: applyOverlapStyles(box),
        }"
      >
        <div v-for="(ability, key) in box.roomAbilities" :key="key">
          <ul class="abilityList" v-if="ability.titles && ability.titles[localLanguageTypesIndex]">
            <li v-if="!allRoomAbilitiesHaveNoIcon">
              <!-- BACK SUPPORT FOR THE OLD ICONS -->
              <v-icon
                v-if="isDynamicIcon(ability)"
                class="icon-wrapper"
                :name="ability.iconName"
                scale="1"
              />
              <v-icon
                v-if="isCheckIcon(ability)"
                class="icon-wrapper"
                name="check"
                scale="1"
              />
              <v-icon
                v-if="isTimesIcon(ability)"
                class="icon-wrapper"
                name="times"
                scale="1"
              />
              <!-- END OF BACK SUPPORT FOR THE OLD ICONS -->
              <div class="icon-wrapper" v-if="!hasIcon(ability)"></div>
            </li>
            <li>{{ ability.titles[localLanguageTypesIndex] }}</li>
          </ul>
        </div>
      </div>
    </div>
    <transition name="fadeInModal">
      <information-box-edit
        :box="box"
        :selectedBoxIndex="index"
        :completeBoxArray="boxes"
        :style="{ zIndex: '99' }"
        @close="closeEditModal"
        v-if="showInfoEditModal"
      >
      </information-box-edit>
    </transition>
    <transition name="fadeInModal">
      <confirm-modal
        @yes="closeWithYes()"
        @no="closeWithNo()"
        v-if="showConfirmModal"
      >
        <h2 slot="title">Delete Box?</h2>
        <p slot="description">The box and its content will be deleted</p>
      </confirm-modal>
    </transition>
  </section>
</template>

<script>
import FloatingActionButtons from "../../BoxesComponents/FloatingActionButtons";
import InformationBoxEdit from "./InformationBoxEdit";
import ConfirmModal from "@/components/GlobalComponents/ConfirmModal.vue";
import VisibilityModal from "@/components/EditGuestbookPage/BoxesComponents/VisibilityModal.vue";
import roomAbilityIconMixin from '@/mixins/roomAbilityIconMixin';
import bus from "@/bus.js";
import { db } from "@/firebase";

export default {
  components: {
    FloatingActionButtons,
    InformationBoxEdit,
    ConfirmModal,
    VisibilityModal,
  },
  mixins: [roomAbilityIconMixin],
  props: {
    box: Object,
    index: Number,
    activeFABIndex: Number,
    boxes: Array,
    customFonts: Object,
    languageTypesIndex: Number,
  },
  data() {
    return {
      showInfoEditModal: false,
      showConfirmModal: false,
      visibilityModalVisible: false,
      visibilityEdited: false,
      localLanguageTypesIndex: 0,
    };
  },
  created() {
    db.ref(`users/${this.$userId}/languageTypesIndex`).on("value", (data) => {
      this.localLanguageTypesIndex = data.val();
    });
  },
  computed: {
    secondLanguage() {
      if (this.languageTypesIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
    allRoomAbilitiesHaveNoIcon() {
      return this.box.roomAbilities.every((ability) => !this.hasIcon(ability));
    }
  },
  methods: {
    showDeleteModal() {
      this.showConfirmModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showEditModal() {
      this.showInfoEditModal = true;
      this.$emit("toggleModal", true);
      bus.$emit("bodyOverflow", true);
    },
    showVisibilityModal() {
      this.visibilityModalVisible = true;
      this.visibilityEdited = false;
      this.$emit("toggleModal", true);
    },
    editVisibility(payload) {
      this.box.visibility = payload;
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/${this.index}`).set(this.box);
      this.visibilityEdited = true;
    },
    closeEditModal() {
      this.showInfoEditModal = false;
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithYes: function () {
      this.showConfirmModal = false;
      this.deleteBox(this.index);
      this.$toastEvents.push({
        type: "copy",
        title: "Deletion",
        content: "The box has been deleted",
        id: +new Date(),
      });
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    closeWithNo: function () {
      if (this.showConfirmModal) {
        this.showConfirmModal = false;
      } else if (this.visibilityModalVisible) {
        this.visibilityModalVisible = false;
        if (this.visibilityEdited) {
          this.$toastEvents.push({
            type: "copy",
            title: "Info",
            content: "The visibility has been edited",
            id: +new Date(),
          });
        }
      }
      this.$emit("toggleModal", false);
      bus.$emit("bodyOverflow", false);
    },
    deleteBox(boxIndex) {
      var newObjToFirebase = this.boxes;
      newObjToFirebase.splice(boxIndex, 1);
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
    },
    isCheckinEmpty(checkinText) {
      return checkinText ? checkinText : "CHECK-IN";
    },
    isCheckoutEmpty(checkoutText) {
      return checkoutText ? checkoutText : "CHECK-OUT";
    },
    applyOverlapStyles(box) {
      if (box.checkinSec && box.checkoutSec) {
        return (
          box.checkins[1].length + box.checkouts[1].length > 25 ||
          box.checkins[0].length + box.checkouts[0].length > 25
        );
      } else {
        return box.checkins[0].length + box.checkouts[0].length > 25;
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h4 {
  margin: 0px;
  color: black;
}
.information-box {
  height: 100%;
}

.infoColumn {
  position: relative;
  background-position: center;
  text-align: center;
  float: left;
  width: 100%;
  padding: 10px;
  padding-top: 25px;
  /* height: 100%; */
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}
div.noCheckInOrCheckOut {
  height: 430px;
}
div.checkInOrCheckoutOverlap {
  height: 275px;
}
div.card-content {
  margin-top: 10px;
  height: fit-content;
  overflow: hidden;
}
.abilityList {
  list-style-type: none;
  margin: 0px;
  padding: 5px 5px 5px 20px;
  text-align: left;
  display: flex;
  align-items: center;
}
.abilityList li {
  display: flex;
  margin-right: 15px;
}
.card-title-custom {
  font-size: 2.5em;
  line-height: 1;
}
.card-title {
  margin: 8px 0 16px 0;
  overflow: hidden;
}
.inAndOut {
  list-style-type: none;
  margin: 0px;
  padding: 5px 5px 5px 20px;
  text-align: left;
}
.inAndOut li {
  display: inline-block;
  margin: 0px 30px 0px 0px;
}
.inAndOut h5 {
  margin-bottom: 5px;
  font-weight: bold;
}

.icon-wrapper {
  width: 15px;
}
</style>
